import { ConditionOperator as ConditionOperatorEnum } from "@sinch/core/entities/serverEnums";
import { useTranslation } from "react-i18next";
import { useEntityProps } from "../utilsHooks";

type SetType = "none" | "single" | "multiple" | "range";

/**
 * Custom hook to manage condition operators.
 */
export const useOperator = () => {
  const { t } = useTranslation();

  const operators: Record<ConditionOperatorEnum, { label: string; setType: SetType }> = {
    [ConditionOperatorEnum.Equal]: { label: "=", setType: "single" },
    [ConditionOperatorEnum.GreaterThan]: { label: ">", setType: "single" },
    [ConditionOperatorEnum.GreaterThanOrEqual]: { label: ">=", setType: "single" },
    [ConditionOperatorEnum.LessThan]: { label: "<", setType: "single" },
    [ConditionOperatorEnum.LessThanOrEqual]: { label: "<=", setType: "single" },
    [ConditionOperatorEnum.NotEqual]: { label: "≠", setType: "single" },

    [ConditionOperatorEnum.In]: { label: t("Operator.in"), setType: "multiple" },
    [ConditionOperatorEnum.NotIn]: { label: t("Operator.notIn"), setType: "multiple" },

    [ConditionOperatorEnum.NotFilled]: { label: t("Operator.notFilled"), setType: "none" },

    [ConditionOperatorEnum.Exist]: { label: t("Operator.exist"), setType: "none" },
    [ConditionOperatorEnum.NotExist]: { label: t("Operator.notExists"), setType: "none" },
  };
  const getProp = useEntityProps(operators);

  const getOperatorLabel = getProp<string>("label");
  const getOperatorSetType = getProp<SetType>("setType");

  return { getOperatorLabel, getOperatorSetType };
};
